// remove-cart.js — removes/hides cart icons that appear later
(function() {
  function removeCart() {
    var selectors = [
      'a[href="/cart"]',
      'a[href$="/cart"]',
      'button[data-icon*="cart"]',
      'button[aria-label*="cart"]',
      '.header__cart',
      '.icon-cart',
      '.cart-icon',
      '.cart-link',
      '.cart-toggle'
    ];
    selectors.forEach(function(sel){
      document.querySelectorAll(sel).forEach(function(el){
        el.style.display = 'none';
        el.style.visibility = 'hidden';
      });
    });
  }
  // run now and a few times later (for JS-rendered icons)
  removeCart();
  var tries = 0;
  var interval = setInterval(function(){
    removeCart();
    tries++;
    if (tries > 10) clearInterval(interval);
  }, 300);
})();
